import script from "./QRCodeShow.vue?vue&type=script&setup=true&lang=ts"
export * from "./QRCodeShow.vue?vue&type=script&setup=true&lang=ts"

import "./QRCodeShow.vue?vue&type=style&index=0&id=be54a568&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be54a568"]])

export default __exports__